import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "@/components/icons";
import { useDocumentMeta } from "@/src/use-document-meta";

// The worker, not the router, renders the jobs directory and the SEO families.
// A client-side navigation into one of those paths falls through to this
// catch-all, so hand the URL back to the server instead of showing a 404 for a
// page that exists.
const SERVER_RENDERED = /^\/(?:sitemap|jobs-in|jobs-in-state|job-titles|company|skills)(?:\/|$)/;
// The path this document was served at. The server already had its say about
// that one, so re-requesting it would loop: an unknown /sitemap/... URL comes
// back as this same shell.
const ENTRY_PATH = typeof window === "undefined" ? "" : window.location.pathname;

export function NotFoundPage() {
  const { pathname, search } = useLocation();
  const serverRendered = SERVER_RENDERED.test(pathname) && pathname !== ENTRY_PATH;
  useDocumentMeta({
    title: "Page not found | Chuno",
    description: "The requested page could not be found.",
    robots: "noindex,nofollow",
    canonical: "https://www.chuno.work/404",
  });
  useEffect(() => {
    if (serverRendered) window.location.replace(`${pathname}${search}`);
  }, [serverRendered, pathname, search]);
  if (serverRendered) return null;
  return <main id="main" className="not-found-page"><div className="shell empty-state"><p className="eyebrow"><span /> 404</p><h1>This page isn’t here.</h1><p>Explore current openings or return to the Chuno homepage.</p><Link to="/jobs">Browse jobs <ArrowRight /></Link></div></main>;
}
